import "./index.scss";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { Button } from "antd";
import { useDispatch } from 'react-redux'
import { useState } from "react";
import { toast } from "react-toastify";
import img from '../../assets/images/cAsset banner module 1.png'


const Cards = () => {

  useEffect(() => {
    dispatch({ type: "CURRENT_LESSON_SET", value: {} });
  }, [])

  const [readMore, setreadMore] = useState(false);
  const [readMoreCardIndex, setReadMoreCardIndex] = useState(0);

  const navigate = useNavigate();
  const dispatch = useDispatch()

  const data = useSelector((state) => state.module.list);
  function sliceText(text) {
    return (
      text.slice(0, 115) + (text.length > 115 ? "..." : "")
    );
  }
  const handleRouteChange = (item) => {
    dispatch({ type: 'CURRENT_MODULE_SET', value: item });
    dispatch({ type: "CURRENT_LESSON_SET", value: item && item.lessons && item.lessons[0] });
    navigate({
      pathname: `/module/${item.id}`,
    });
  };

  const comingSoon = () => {
    toast.info(
      <span className='toast'>Module Coming Soon</span>,
      {
        position: "bottom-center",
      }
    );
  }
  return (
    <section>
      <div className="cards-bg">
        <div className="container">
          <div className="cards-main-container  courese_card">
            <div className="cards-container">
              {data.map((item, index) => {
                return (
                  <div className="single-cards" key={index}>
                    <div className="cards-img-container">
                      <img src={item.img} alt="" />
                      {(item.comingSoon === false) ? (
                        <div className="circle" onClick={() => handleRouteChange(item)} ></div>
                      ) : <div className="circle" onClick={() => comingSoon()} ></div>}
                    </div>
                    <div className="cards-module">
                      <div className="btn-primary">{item.module}</div>
                    </div>
                    <div className="cards-title">{item.title}</div>
                    <div className="cards-description">{readMoreCardIndex === index && readMore ?
                      (item.description) : sliceText(item.description)}
                      <span className="readMore" onClick={() => {
                        setreadMore(readMoreCardIndex === index ? !readMore : readMore)
                        setReadMoreCardIndex(index);
                      }
                      } >{readMoreCardIndex === index && readMore ? " Show Less" : " Read More"}</span>
                    </div>
                    <div className="cards-button">
                      {(item.comingSoon === false) ? (
                        <Button
                          type="primary"
                          onClick={() => handleRouteChange(item)}
                          className="btn-filled"
                          size="small"
                        >
                          Explore &rarr;
                        </Button>
                      ) : <Button
                        type="primary"
                        onClick={() => comingSoon()}
                        className="btn-filled"
                        size="small">Coming Soon &rarr;</Button>}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Cards;
